<template>
  <div class="full-width">
    <div class="left-corner-box">
      <img
        @click="goPageBack"
        v-if="view_info.index > 0"
        src="@/assets/images/back-button.svg"
        width="20"
        style="opacity: 30%; margin-right: 5%; cursor: pointer"
      />
      <div class="step-txt-block">STAP {{ view_info.page }} VAN 3</div>
    </div>
    <div class="donation-title">{{ view_info.title }}</div>
    <p class="donation-paragraph">{{ view_info.subtitle }}</p>
  </div>
</template>

<script>
export default {
  props: ["page_id"],
  async created() {},
  data: () => {
    return {
      info: [
        {
          index: 0,
          id: "step1",
          page: 1,
          title: "Jouw bijdrage telt!",
          subtitle:
            "Door het verzenden van dit formulier wordt uw aanmelding naar de respectievelijke stad gestuurd.",
        },
        {
          index: 1,
          id: "step2_once",
          page: 2,
          title: "Jouw bijdrage telt!",
          subtitle:
            "Door het verzenden van dit formulier wordt uw aanmelding naar de respectievelijke stad gestuurd.",
        },

        {
          index: 2,
          id: "step2_recurring",
          page: 2,
          title: "Jouw bijdrage telt!",
          subtitle:
            "Door het verzenden van dit formulier wordt uw aanmelding naar de respectievelijke stad gestuurd.",
        },
        {
          index: 3,
          id: "step3",
          page: 3,
          title: "Jouw bijdrage telt!",
          subtitle:
            "Door het verzenden van dit formulier wordt uw aanmelding naar de respectievelijke stad gestuurd.",
        },
      ],
    }
  },
  computed: {
    view_info: function () {
      let index = this.$store.state.page.index
      return this.getInfo(this.$store.state.page.path[index - 1].name)
    },
  },
  methods: {
    getInfo(page_id) {
      for (let i = 0; i < this.info.length; i++) {
        if (this.info[i].id === page_id) {
          return this.info[i]
        }
      }
    },
    goPageBack() {
      this.$emit("goBack", true)
    },
  },
}
</script>

<style scoped>
.left-corner-box {
  display: flex;
  justify-content: flex-start;
  align-items: "center";
  flex-direction: row;
}
</style>
